import { usePrincipalId } from "../../../lib/browser-state";
import { organizationsQuery } from "../../../lib/account";
import { useQuery } from "../../../lib/server-query";
import { createFileRoute } from "@tanstack/react-router";
import { EmptyState, Icon } from "@sx/ui";

import { Region } from "../../../components/Region";
import { RouteFallback } from "../../../shell/RouteFallback";
import {
  DeleteOrganizationCard,
  OrganizationPanel,
} from "../../../workspaces/settings/OrganizationPanel";
import { OrganizationProjectsPanel } from "../../../workspaces/settings/ProjectsPanel";

export const Route = createFileRoute("/_console/settings/organizations/$organizationId")({
  component: OrganizationSettingsRoute,
});

function OrganizationSettingsRoute() {
  const { organizationId } = Route.useParams();
  const rows = useQuery({ ...organizationsQuery(usePrincipalId()) });
  return (
    <Region
      query={rows}
      title="Organizations"
      placeholder={
        <RouteFallback />
      }
    >
      {(organizationRows) => {
        const organization = organizationRows.find((row) => row.id === organizationId);
        if (!organization) {
          return (
            <EmptyState
              icon={<Icon name="organization" />}
              title="Organization unavailable"
              hint="Choose an organization from the avatar menu."
            />
          );
        }
        return (
          <div className="space-y-5">
            <OrganizationPanel organization={organization} />
            <OrganizationProjectsPanel organization={organization} />
            <DeleteOrganizationCard organization={organization} />
          </div>
        );
      }}
    </Region>
  );
}
